"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const short_uuid_1 = __importDefault(require("short-uuid"));
const api_1 = require("../api");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const debug = debug_1.default('notification-service');
class NotificationService {
    constructor(store) {
        this.store = store;
    }
    show(notification) {
        debug('show', notification);
        if (!this.subject) {
            throw new Error('Coding error: notification service not started');
        }
        this.subject.next({
            name: 'show',
            notification: notification
        });
    }
    hide(id) {
        if (!this.subject) {
            throw new Error('Coding error: notification service not started');
        }
        this.subject.next({
            name: 'hide',
            id
        });
    }
    start() {
        this.subject = new rxjs_1.Subject();
        this.observable = this.subject.pipe(operators_1.mergeMap(input => {
            switch (input.name) {
                case 'show':
                    return this.showObservable(input.notification);
                case 'hide':
                    return this.hideObservable(input.id);
            }
        }), operators_1.distinctUntilChanged((x, y) => x.name + x.notification.id === y.name + y.notification.id), // do not duplicate removes
        operators_1.map(x => this.applyCommand(x)));
        this.subscription = this.observable.subscribe({
            error: (err) => {
                throw err;
            }
        });
    }
    finish() {
        if (!this.subscription) {
            throw new Error('Coding error: notification service not started');
        }
        this.subscription.unsubscribe();
        this.subscription = undefined;
        this.observable = undefined;
        this.subject = undefined;
    }
    showObservable(notification) {
        const id = notification.id || short_uuid_1.default.generate();
        let output$ = rxjs_1.of({
            name: 'show',
            notification: {
                id: id,
                type: notification.type,
                payload: notification.payload,
                options: {
                    ...notification.options
                }
            }
        });
        if (notification.options.display === 'autohide') {
            output$ = rxjs_1.concat(output$, this.hideObservable(id).pipe(operators_1.delay(api_1.NotificationConfig.autohideMs)));
        }
        return output$;
    }
    hideObservable(id) {
        const hide$ = rxjs_1.of({
            name: 'hide',
            notification: { id }
        });
        const remove$ = rxjs_1.of({
            name: 'remove',
            notification: { id }
        }).pipe(operators_1.delay(api_1.NotificationConfig.removeAfterHideMs));
        return rxjs_1.concat(hide$, remove$);
    }
    applyCommand(command) {
        switch (command.name) {
            case 'show':
                this.store.add(command.notification);
                break;
            case 'hide':
                this.store.hide(command.notification);
                break;
            case 'remove':
                this.store.remove(command.notification);
                break;
        }
    }
}
exports.NotificationService = NotificationService;
//# sourceMappingURL=notification-service.js.map